/*
 * VideoPlayer Specification
 * This contains tests for the VideoPlayer component.
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { Player, BigPlayButton } from 'video-react';
import { FormattedMessage } from 'react-intl';

// $FlowIssue
import { ReactComponent as DownloadIcon } from '@/icons/ic-download.svg';

import messages from './messages';

import 'video-react/dist/video-react.css';

export type VideoPlayerProps = {
  imageSrc?: string,
  videoSrc?: string,
};

const VideoPlayerWrapper = styled.div`
  position: relative;
  max-width: 960px;
  width: 100%;
  height: auto;
`;

const VideoPlayerDownloadButton = styled.a`
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  min-width: 132px;
  min-height: 32px;
  align-items: center;
  background-color: #043267;
  color: #fff;
  font-size: 14px;
  justify-content: center;
  opacity: 0.8;
  text-decoration: none;

  svg {
    margin-right: 10px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

/**
 * VideoPlayer React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.imageSrc] - image source
 * @param {string} [props.videoSrc] - video source
 * @example <caption>Simple usage</caption>
 * <VideoPlayer />
 * @returns {React.Node<*>} React-component
 */
export const VideoPlayer = ({ videoSrc, imageSrc }: VideoPlayerProps) => {
  const config = {
    src: videoSrc,
    poster: imageSrc,
    playsInline: true,
    preload: 'none',
  };

  return (
    <VideoPlayerWrapper testid="video-player">
      <Player {...config}>
        <BigPlayButton position="center" />
      </Player>
      <VideoPlayerDownloadButton href={videoSrc}>
        <DownloadIcon />
        <FormattedMessage {...messages.downloadButton} />
      </VideoPlayerDownloadButton>
    </VideoPlayerWrapper>
  );
};
